<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container">
    <mat-card class="loading-card">
        <mat-card-content class="loading-content">
            <mat-spinner diameter="50"></mat-spinner>
            <p class="loading-text">{{ loadingMessage }}</p>
        </mat-card-content>
    </mat-card>
</div>

<!-- Error State -->
<div *ngIf="error && !isLoading" class="error-container">
    <mat-card class="error-card">
        <mat-card-content class="error-content">
            <mat-icon class="error-icon">error</mat-icon>
            <h3 class="error-title">Error al cargar datos</h3>
            <p class="error-message">{{ error }}</p>
            <button mat-raised-button color="primary" (click)="volver()">
                <mat-icon>arrow_back</mat-icon>
                Volver a la lista
            </button>
        </mat-card-content>
    </mat-card>
</div>

<!-- Main Content -->
<div *ngIf="!isLoading && !error && liquidacion" class="detalle-container">
    <mat-card class="trinta-card mb-25 bg-white border-none d-block liquidacion-detalle-card">
      <mat-card-header class="liquidacion-header d-flex align-items-center justify-content-between">
        <div class="header-left">
          <button
            mat-stroked-button
            color="primary"
            class="back-button"
            (click)="volver()"
            aria-label="Volver al listado"
          >
            <mat-icon class="mr-1">arrow_back</mat-icon>
            Volver al Listado
          </button>
        </div>
        <div class="header-right flex-grow-1 text-right">
          <h4 class="mb-0 mt-2 text-primary fw-bold">
            Liquidación VD
          </h4>
          <p class="subtitle text-secondary mb-0">
            {{ liquidacion?.cliente || 'N/A' }} - {{ liquidacion?.mesAnio ? formatearMesAnio(liquidacion.mesAnio) : obtenerMesAnioDesdeFecha(liquidacion?.fromDate || liquidacion?.toDate) }}
          </p>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="status-row">
          <div class="estado-block">
            <span
              [ngClass]="getEstadoColor(liquidacion.estado) + ' estado-chip destacado'"
              aria-label="Estado de la liquidación"
            >
              {{ liquidacion.estado || 'Pendiente' }}
            </span>
          </div>
          <div class="fecha-block">
            <span class="date-info">
              <span class="fecha-label">Fecha de Liquidación:</span>
              <mat-icon class="mr-1" fontIcon="calendar_today"></mat-icon>
              {{ formatearFecha(liquidacion.fechaLiquidacion || liquidacion.fromDate) }}
            </span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Contenedor para tabla -->
    <mat-card class="trinta-card mb-25 bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">Detalle de Contenedores 
                    <span *ngIf="totalesContenedores">({{ totalesContenedores.totalContenedores }})</span>
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <!-- Loading para contenedores -->
            <div *ngIf="isLoadingContenedores" class="loading-section">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Cargando contenedores...</p>
            </div>
            
            <!-- Tabla de contenedores -->
            <div *ngIf="!isLoadingContenedores && contenedores.length > 0" class="liquidaciones-list-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="contenedoresDataSource" matSort #contenedoresSort="matSort">
                    <!-- Tráfico -->
                    <ng-container matColumnDef="trafico">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-0">Tráfico</th>
                        <td mat-cell *matCellDef="let contenedor" class="pl-0">{{ contenedor.trafico || 'N/D' }}</td>
                    </ng-container>

                    <!-- Exportador -->
                    <ng-container matColumnDef="exportador">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Exportador</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.exportador || 'N/D' }}</td>
                    </ng-container>

                    <!-- Naviera -->
                    <ng-container matColumnDef="naviera">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Naviera</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.naviera || 'N/D' }}</td>
                    </ng-container>

                    <!-- Nave -->
                    <ng-container matColumnDef="nave">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nave</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.nave || 'N/D' }}</td>
                    </ng-container>

                    <!-- Viaje -->
                    <ng-container matColumnDef="viaje">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Viaje</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.viaje || 'N/D' }}</td>
                    </ng-container>

                    <!-- Fecha Embarque -->
                    <ng-container matColumnDef="fechaEmbarque">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Embarque</th>
                        <td mat-cell *matCellDef="let contenedor">{{ formatearFechaCorta(contenedor.fechaEmbarque) }}</td>
                    </ng-container>

                    <!-- Embarque -->
                    <ng-container matColumnDef="embarque">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Embarque</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.embarque || 'N/D' }}</td>
                    </ng-container>

                    <!-- Descarga -->
                    <ng-container matColumnDef="descarga">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descarga</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.descarga || 'N/D' }}</td>
                    </ng-container>

                    <!-- Grupo Especie -->
                    <ng-container matColumnDef="grupoEspecie">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Grupo Especie</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.grupoEspecie || 'N/D' }}</td>
                    </ng-container>

                    <!-- Especie -->
                    <ng-container matColumnDef="especie">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Especie</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.especie || 'N/D' }}</td>
                    </ng-container>

                    <!-- Booking -->
                    <ng-container matColumnDef="booking">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Booking</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.booking || 'N/D' }}</td>
                    </ng-container>

                    <!-- BL -->
                    <ng-container matColumnDef="bl">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>BL</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.bl || 'N/D' }}</td>
                    </ng-container>

                    <!-- Contenedor -->
                    <ng-container matColumnDef="contenedor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contenedor</th>
                        <td mat-cell *matCellDef="let contenedor">{{ contenedor.contenedor || 'N/D' }}</td>
                    </ng-container>

                    <!-- Cantidad -->
                    <ng-container matColumnDef="cantidad">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Cantidad</th>
                        <td mat-cell *matCellDef="let contenedor" class="text-end">{{ formatearNumero(contenedor.cantidad) }}</td>
                    </ng-container>

                    <!-- Tarifa Pública -->
                    <ng-container matColumnDef="tarifaPublica">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Tarifa Pública</th>
                        <td mat-cell *matCellDef="let contenedor" class="text-end">{{ formatearMoneda(contenedor.tarifaPublica) }}</td>
                    </ng-container>

                    <!-- Tarifa Neta -->
                    <ng-container matColumnDef="tarifaNeta">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Tarifa Neta</th>
                        <td mat-cell *matCellDef="let contenedor" class="text-end">{{ formatearMoneda(contenedor.tarifaNeta) }}</td>
                    </ng-container>

                    <!-- VD USD -->
                    <ng-container matColumnDef="vdUsd">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">VD USD</th>
                        <td mat-cell *matCellDef="let contenedor" class="text-end">{{ formatearMonedaUsd(contenedor.vdUsd) }}</td>
                    </ng-container>

                    <!-- TC -->
                    <ng-container matColumnDef="tc">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">TC</th>
                        <td mat-cell *matCellDef="let contenedor" class="text-end">{{ formatearNumero(contenedor.tc) }}</td>
                    </ng-container>

                    <!-- VD CLP -->
                    <ng-container matColumnDef="vdClp">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">VD CLP</th>
                        <td mat-cell *matCellDef="let contenedor" class="text-end">{{ formatearMoneda(contenedor.vdClp) }}</td>
                    </ng-container>

                        <tr mat-header-row *matHeaderRowDef="contenedoresColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: contenedoresColumns;"></tr>
                    </table>
                </div>

                <!-- Paginación -->
                <mat-paginator 
                    #contenedoresPaginator 
                    [length]="contenedoresDataSource.data.length" 
                    [pageSize]="10" 
                    [pageSizeOptions]="[10, 25, 50, 100]" 
                    [hidePageSize]="false" 
                    showFirstLastButtons>
                </mat-paginator>

                <!-- Fila de totales -->
                <div *ngIf="totalesContenedores" class="liquidaciones-list-table mt-3">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="[{totales: totalesContenedores}]">
                        <ng-container matColumnDef="trafico">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef class="pl-0">Totales</td>
                        </ng-container>
                        <ng-container matColumnDef="exportador">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="naviera">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="nave">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="viaje">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="fechaEmbarque">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="embarque">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="descarga">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="grupoEspecie">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="especie">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="booking">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="bl">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="contenedor">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="cantidad">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef class="text-end">
                                <strong>{{ formatearNumero(totalesContenedores.totalContenedores) }}</strong>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="tarifaPublica">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef class="text-end"></td>
                        </ng-container>
                        <ng-container matColumnDef="tarifaNeta">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef class="text-end"></td>
                        </ng-container>
                        <ng-container matColumnDef="vdUsd">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef class="text-end">
                                <strong>{{ formatearMonedaUsd(totalesContenedores.totalVdUsd) }}</strong>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="tc">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef class="text-end"></td>
                        </ng-container>
                        <ng-container matColumnDef="vdClp">
                            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                            <td mat-footer-cell *matFooterCellDef class="text-end">
                                <strong>{{ formatearMoneda(totalesContenedores.totalVdClp) }}</strong>
                            </td>
                        </ng-container>

                            <tr mat-header-row *matHeaderRowDef="contenedoresColumns" style="display: none;"></tr>
                            <tr mat-footer-row *matFooterRowDef="contenedoresColumns" class="totales-footer-row"></tr>
                        </table>
                    </div>
                </div>
            </div>
            
            <div *ngIf="!isLoadingContenedores && contenedores.length === 0" class="no-data">
                <mat-icon>info</mat-icon>
                <p>No hay contenedores registrados para esta liquidación</p>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<!-- Mensaje cuando no hay datos -->
<div class="no-data" *ngIf="!isLoading && !error && !liquidacion">
    <mat-icon>info</mat-icon>
    <p>No se encontró la liquidación solicitada.</p>
    <button mat-raised-button color="primary" (click)="volver()">
        <mat-icon>arrow_back</mat-icon>
        Volver al listado
    </button>
</div>
